import { useSelector } from "react-redux";
import { canRedeemPointsOnPos } from "../provider";
import {
  selectActiveLoyaltyProvider,
  selectCustomerPhone,
  selectIsOffline,
  selectLoyaltyProgramDetails,
} from "../selectors";
import { useEnsureProgramDetails } from "./useProgramDetailsFetch";

/**
 * Should the redemption panel be mounted at all?
 *
 * 🔴 **The one gate, for every surface.** It needs a customer to redeem for, a connection (the
 * loyalty APIs are server-backed) and a provider that permits POS redemption. The three used to
 * be spelled out at one of the panel's two mount points and only partly at the other, so the
 * tablet layout showed the panel for providers the desktop layout hid it for. A new surface
 * (kiosk, mobile) gets the whole rule by calling this.
 *
 * 🔴 **It fetches the programme it gates on (2026-09-23).** For a programme-driven partner
 * (`requiresLiveProgramToRedeem`) an empty cache answers "no", and the only other fetch is each
 * app's `NewOrder`, which a checkout opened from Table View or My Orders never passes. The fetch
 * has to live HERE: the panel mounts behind this gate, so a fetch inside the panel could never
 * run. See `useEnsureProgramDetails`.
 */
export function useCanRedeemPoints(): boolean {
  const customerPhone = useSelector(selectCustomerPhone);
  const isOffline = useSelector(selectIsOffline);
  const activeProvider = useSelector(selectActiveLoyaltyProvider);
  const programDetails = useSelector(selectLoyaltyProgramDetails);

  // Only once the programme is all that is left to decide: with no customer the answer is "no"
  // whatever it says. (The ensure skips offline itself.)
  useEnsureProgramDetails(!!customerPhone);

  return !!customerPhone && !isOffline && canRedeemPointsOnPos(activeProvider?.metaId, programDetails);
}
